import React from "react";
import { Container } from "react-bootstrap";
import { string } from "prop-types";

const About = ({ title, text }) => {
  return (
    <section id="about" className="bg-color-2 page-section text-center">
      <Container>
        <h2>{title}</h2>
        <hr className="small" />
        <p className="lead">{text}</p>
      </Container>
    </section>
  );
};

About.propTypes = {
  title: string.isRequired,
  text: string.isRequired
};

export default About;
